import React from 'react';
import { ShieldCheck } from 'lucide-react';
import styles from './BoxTraySleeveHero.module.css';

const BoxTraySleeveHero = ({
  badge,
  scriptTitle,
  mainTitleLines,
  kicker,
  descriptions,
  features,
  imagePrimary,
  imageSecondary,
}) => (
  <section className={styles.heroSection}>
    <div className={styles.glowOrb} aria-hidden="true" />

    <div className={styles.inner}>
      <div className={styles.layout}>
        <div className={styles.copyCol}>
          <span className={styles.badge}>{badge}</span>

          <div className={styles.titleBlock}>
            <span className={styles.eyebrow}>{scriptTitle}</span>
            <h1 className={styles.title}>
              {mainTitleLines[0]}
              <span className={styles.titleAccent}>{mainTitleLines[1]}</span>
            </h1>
          </div>

          {kicker && <p className={styles.kicker}>{kicker}</p>}

          <div className={styles.bodyCopy}>
            {descriptions.slice(0, 2).map((text, index) => (
              <p key={index} className={styles.paragraph}>
                {text}
              </p>
            ))}
          </div>

          {features?.length > 0 && (
            <ul className={styles.featureRow}>
              {features.map((feature, index) => (
                <li key={index} className={styles.featureChip}>
                  <ShieldCheck size={12} aria-hidden="true" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.visualCol}>
          <div className={styles.fanStage}>
            {imageSecondary && (
              <figure className={styles.cardBack}>
                <img src={imageSecondary.src} alt={imageSecondary.alt} />
              </figure>
            )}
            {imagePrimary && (
              <figure className={styles.cardFront}>
                <img src={imagePrimary.src} alt={imagePrimary.alt} />
              </figure>
            )}
            <span className={styles.accentStripe} aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BoxTraySleeveHero;
